const CELL_RE = /^\$?([A-Z]+)\$?(\d+)$/i;
const COL_RE = /^\$?([A-Z]+)\$?$/i; // e.g. "A", "$AA$"
const ROW_RE = /^\$?(\d+)\$?$/; // e.g. "3", "$10$"
function parseToken(t) {
    if (CELL_RE.test(t)) {
        const [, letters, rowStr] = CELL_RE.exec(t);
        return { kind: 'cell', r: +rowStr - 1, c: colLettersToIdx(letters.toUpperCase()) };
    }
    if (COL_RE.test(t)) {
        const [, letters] = COL_RE.exec(t);
        return { kind: 'col', c: colLettersToIdx(letters.toUpperCase()) };
    }
    if (ROW_RE.test(t)) {
        const [, rowStr] = ROW_RE.exec(t);
        return { kind: 'row', r: +rowStr - 1 };
    }
    return null;
}
export function splitSheetAndBody(addr) {
    const bang = addr.lastIndexOf('!');
    if (bang === -1)
        return { body: addr }; // no sheet part
    let name = addr.slice(0, bang);
    // Strip surrounding single quotes and unescape doubled quotes
    if (name.startsWith("'") && name.endsWith("'")) {
        name = name.slice(1, -1).replace(/''/g, "'");
    }
    return { sheetName: name, body: addr.slice(bang + 1) };
}
function colLettersToIdx(letters) {
    let n = 0;
    for (let i = 0; i < letters.length; i++)
        n = n * 26 + (letters.charCodeAt(i) - 64);
    return n - 1;
}
function a1CellToRC(a1) {
    const m = /^\$?([A-Z]+)\$?(\d+)$/i.exec(a1);
    if (!m)
        throw new Error(`Bad A1 cell: ${a1}`);
    const [, colLetters, rowStr] = m;
    return { r: parseInt(rowStr, 10) - 1, c: colLettersToIdx(colLetters.toUpperCase()) };
}
export function rangeToRect(body) {
    const [a, b] = body.split(':');
    const t1 = parseToken(a);
    const t2 = b ? parseToken(b) : t1;
    if (!t1 || !t2)
        throw new Error(`Bad A1 token(s): ${a}:${b}`);
    // Column-only: "A:A"
    if (t1.kind === 'col' && t2.kind === 'col') {
        const c0 = Math.min(t1.c, t2.c), c1 = Math.max(t1.c, t2.c);
        return { r0: 0, c0, r1: Number.POSITIVE_INFINITY, c1 };
    }
    // Row-only: "3:3"
    if (t1.kind === 'row' && t2.kind === 'row') {
        const r0 = Math.min(t1.r, t2.r), r1 = Math.max(t1.r, t2.r);
        return { r0, c0: 0, r1, c1: Number.POSITIVE_INFINITY };
    }
    // Mixed types like "A:5" are rare/ambiguous; decide how you want to handle them.
    // Standard Excel treats "A:5" as invalid, so you can throw here:
    if (t1.kind !== 'cell' || t2.kind !== 'cell') {
        throw new Error(`Unsupported range form: ${body}`);
    }
    // Normal cell:cell rectangle
    const r0 = Math.min(t1.r, t2.r), r1 = Math.max(t1.r, t2.r);
    const c0 = Math.min(t1.c, t2.c), c1 = Math.max(t1.c, t2.c);
    return { r0, c0, r1, c1 };
}
export function cellInRect(cellA1, rect) {
    const { r, c } = a1CellToRC(cellA1);
    return r >= rect.r0 && r <= rect.r1 && c >= rect.c0 && c <= rect.c1;
}
export function sameSheetName(a, b) {
    if (!a || !b)
        return false;
    const norm = (s) => s
        .replace(/^'(.*)'$/, '$1')
        .replace(/''/g, "'")
        .toLowerCase();
    return norm(a) === norm(b);
}
//# sourceMappingURL=excel-helpers.js.map